import {
  Button,
  Paper,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles
} from '@material-ui/core';
import React from 'react';
import { Table } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import CancelButton from '../atoms/CancelButton';

const styles = {
  contentContainer: {
    padding: 40,
    backgroundColor: '#fff',
    borderRadius: 4
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 5
  },
  body: {
    padding: '0 40px'
  },
  table: {
    width: '100%'
  },
  tableHeader: {
    backgroundColor: 'rgba(224, 224, 224, 1)',
    marginTop: '5px'
  },
  tableCell: {
    borderTop: '1px solid rgba(224, 224, 224, 1)',
    fontSize: 14,
    width: '50%'
  },
  tableCellData: {
    fontSize: 16,
    fontWeight: 700
  },
  paper: {
    padding: 20
  },
  noteText: {
    fontSize: 16,
    fontWeight: 400,
    marginTop: 20
  },
  redText: {
    color: '#F50057'
  },
  buttonBox: {
    marginTop: 20
  }
};

const enhance = compose();

const Main = enhance(
  ({
    classes,
    updateOpenSettingGochiKidReceiptModal,
    shop,
    updateSettingGochiKidReceipt
  }) => {
    return (
      <div className={classes.contentContainer}>
        <div className={classes.body}>
          <Typography className={classes.title} variant="h6">
            こどもごちめし レシート対応
          </Typography>
          <Paper className={classes.paper}>
            <Table className={classes.table}>
              <TableHead className={classes.tableHeader}>
                <TableRow>
                  <TableCell className={classes.tableCell}>店舗ID</TableCell>
                  <TableCell className={classes.tableCell}>店舗名</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCellData}>
                    {shop.shopId}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {shop.shopName}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>

            {shop.shopDetail && shop.shopDetail.gochiKidReceipt === 1 ? (
              <div className={classes.noteText}>
                現在、レシート対応はONになっています。
                <span className={classes.redText}>OFF</span>
                に変更してもよろしいですか？
              </div>
            ) : (
              <div className={classes.noteText}>
                現在、レシート対応はOFFになっています。
                <span className={classes.redText}>ON</span>
                に変更してもよろしいですか？
              </div>
            )}
          </Paper>

          <div className={classes.buttonBox}>
            <CancelButton
              color="primary"
              onClickAction={() => {
                updateOpenSettingGochiKidReceiptModal(false);
              }}
            />

            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                updateSettingGochiKidReceipt();
              }}
            >
              OK
            </Button>
          </div>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
